import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  Text,
  useColorModeValue,
  Link,
  IconButton,
  Flex,
} from '@chakra-ui/react'
import { useState } from 'react'
import axios from "axios";
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons'
import baseURL from '../config/baseURL';

type Props = {
  onSignUpProcessDone: () => void;
};

export default function SignUpPage({onSignUpProcessDone}:Props) {
  const [showPassword, setShowPassword] = useState(false)
  const [firstName, setFirstName] = useState("");
  const [secondName, setSecondName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState('')

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    let endpoint =
      baseURL + "/auth/users/";
    let userData = {
      username: email,
      email: email,
      first_name: firstName,
      last_name: secondName,
      phone: phone,
      password: password,
    };

   
  
    let options = {
      headers: { Accept: "application/json" },
      validateStatus: (status: number) => status >= 200 && status < 300,
    };
  
    try {
      const response = await axios.post(endpoint, userData, options);
      console.log('response.data from sign up', response.data);
      await new Promise((resolve) => setTimeout(resolve, 1500));
      alert('Account created successfully. Proceed to sign into your account.');
      onSignUpProcessDone();
    } catch (error: any) {
      if (error.response) {
        const errorDetails = error.response.data;
        let errorMessage = "An error occurred.";
  
        if (errorDetails.username) {
          errorMessage = errorDetails.username.join(" ");
        } else if (errorDetails.email) {
          errorMessage = errorDetails.email.join(" ");
        } else if (errorDetails.password) {
          errorMessage = errorDetails.password.join(" ");
        } else {
          errorMessage = error.response.data.detail || "Invalid input.";
        }
        setError(errorMessage);
        console.error("Error details:", errorDetails);
        console.error("Error Message:", errorMessage);
      } else if (error.request) {
        setError("Network error: Unable to reach the server.");
      } else {
        setError("Unexpected error occurred. Please try again.");
      }
      console.error("Error details:", error);
    }
  };
  

  return (
      <Box
        rounded="lg"
        bg={useColorModeValue('white', 'gray.700')}
        boxShadow="lg"
        p={8}
        maxW="md"
        w="full"
      >
        <Stack spacing={4}>
          <Heading
            fontSize="2xl"
            textAlign="center"
            color="#006400"
          >
            Create your account
          </Heading>
          <Text fontSize="sm" textAlign="center" color="gray.500">
            Manage your business operations efficiently all in one place!
          </Text>
          <Text fontSize="m" textAlign="center" color="red.500">
            {error}
          </Text>

          <form onSubmit={handleSubmit}>
            <FormControl id="firstName" isRequired>
              <FormLabel>First Name</FormLabel>
              <Input 
                placeholder="John" 
                value={firstName}
                onChange={(event) => {
                  setFirstName(event.target.value);
                }}
              />
            </FormControl>
            <FormControl id="secondName" isRequired>
              <FormLabel>Second Name</FormLabel>
              <Input 
                placeholder="eg. Doe" 
                value={secondName}
                onChange={(event) => {
                  setSecondName(event.target.value);
                }}
              />
            </FormControl>
            <FormControl id="phone" isRequired>
              <FormLabel>Phone</FormLabel>
              <Input 
                placeholder="+26377123456" 
                value={phone}
                onChange={(event) => {
                  setPhone(event.target.value);
                }}
              />
            </FormControl>

            <FormControl id="email" isRequired>
              <FormLabel>Email address</FormLabel>
              <Input 
                type="email" 
                placeholder="john@example.com" 
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}  
              />
            </FormControl>

            <FormControl id="password" isRequired>
              <FormLabel>Password</FormLabel>
              <InputGroup>
                <Input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter password"
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                  }} 
                />
                <InputRightElement h="full">
                  <IconButton
                    variant="ghost"
                    aria-label="Toggle Password Visibility"
                    // icon={showPassword ? 'ViewOffIcon' : 'ViewIcon'}
                    icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                    onClick={() =>
                      setShowPassword((showPassword) => !showPassword)
                    }
                  />
                </InputRightElement>
              </InputGroup>
            </FormControl>

            <Stack spacing={6} pt={4}>
              <Button
                type='submit'
                loadingText="Submitting"
                size="lg"
                bg="#006400"
                color="white"
                _hover={{ bg: '#004d00' }}
              >
                Sign up
              </Button>

              {/* <Button variant="outline" color="#006400" borderColor="#006400">
                Sign up with Google
              </Button> */}
            </Stack>
          </form>
        </Stack>
      </Box>
  )
}
